export class CostDataRecordDimensions {
    'cloudProvider';
    'resourceType';
    'resourceId';
    'sourceAccountProviderId';
    'sourceAccountId';
    'sourceAccountName';
    'sourceAccountTags';
    'sourceStorageSize';
    'providerResourceId';
    'resourceName';
    'resourceTags';
    'resourceSourceRegion';
    'vaultId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "sourceAccountProviderId",
            "baseName": "sourceAccountProviderId",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceAccountId",
            "baseName": "sourceAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "sourceAccountName",
            "baseName": "sourceAccountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceAccountTags",
            "baseName": "sourceAccountTags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "sourceStorageSize",
            "baseName": "sourceStorageSize",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceTags",
            "baseName": "resourceTags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "resourceSourceRegion",
            "baseName": "resourceSourceRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CostDataRecordDimensions.attributeTypeMap;
    }
    constructor() {
    }
}
